import { omitNonAlphaNumericCharacters } from 'src/lib/string';

export const uploadFileToS3 = async ({ url, file, onProgress }) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress?.(Math.round((event.loaded / event.total) * 100));
      }
    };
    xhr.onload = () => {
      if (xhr.status === 200) {
        onProgress?.(100);

        const etag = xhr.getResponseHeader('Etag');
        resolve({ checksum: omitNonAlphaNumericCharacters(etag) });
      } else {
        reject(new Error('Upload failed with status ' + xhr.status));
      }
    };
    xhr.onerror = () => reject(new Error('Upload error'));
    xhr.send(file);
  });
